import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import InputText from "../../../components/Forms/Element/InputText";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import FormSection from "../../../components/Common/Form/FormSection";

const Form = (props) => {

    const { t } = useTranslation();
    const { status, setStatus, formik, entityData } = props;

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('name', entityData.name);
            setStatus(convertStatusToBoolean(entityData.status));
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('sales_reason_basic_information_hint')}
                    icon="fa-solid fa-ban"
                >
                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('reason')} <AsteriskRequired /></FormLabel>
                                <InputText
                                    name="name"
                                    placeholder={t('reason_name_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                    maxLength={150}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('status')}
                    description={t('sales_reason_status_hint')}
                    icon="fa-solid fa-toggle-on"
                    compact
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
